import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { Report } from 'src/app/_models/report';

@Component({
    selector: 'app-annualRoll',
    templateUrl: './annualRoll.component.html',
    styleUrls: ['./annualRoll.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnnualRollComponent implements OnInit {
  items: Report[];
  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.apiService.getReports().subscribe(data => {
      this.items = data;
      console.log(this.items)
    })
  }

}
